const sprdLocaleMapping: Record<string, string> = {
  dk_DK: 'da_DK',
  en_EU: 'en_IE',
  se_SE: 'sv_SE',
  us_AU: 'en_AU',
  us_CA: 'en_CA',
  us_US: 'en_US',
} as const;

export function convertSprdLocaleToSprdIsoLocale(locale: string) {
  return sprdLocaleMapping[locale] || locale;
}

export function convertSprdLocaleToIsoLocale(locale: string) {
  return convertSprdLocaleToSprdIsoLocale(locale).replace('_', '-');
}
